/**
 * Soft, low-saturation chip tones so icon rows don't read as one monotone block
 * and never compete with the product covers.
 * Cycled by index across card lists.
 */
export interface IconTone {
  bg: string
  fg: string
}

export const iconTones: IconTone[] = [
  { bg: 'bg-forest-100', fg: 'text-forest-600' },
  { bg: 'bg-ember-100', fg: 'text-ember-600' },
  { bg: 'bg-[#DCE5DE]', fg: 'text-[#3D5B4A]' },
  { bg: 'bg-[#DFE2EA]', fg: 'text-[#414D66]' },
  { bg: 'bg-[#F1DFD4]', fg: 'text-[#8A4A24]' },
  { bg: 'bg-[#E8E2CF]', fg: 'text-[#5F5726]' },
]

export function toneAt(index: number): IconTone {
  return iconTones[index % iconTones.length]
}
